import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { ACTION_TYPE } from "@circle-react/types/PaywallCustomization";
import { Form } from "@circle-react-shared/uikit/Form";

interface ActionTypeOptionsProps {
  formClassName: string;
  name: string;
  translationRoot: string;
}

export const ActionTypeOptions = ({
  name,
  formClassName,
  translationRoot,
}: ActionTypeOptionsProps) => {
  const { getValues } = useFormContext();

  const actionTypeInitialValue = getValues(name);

  return (
    <Form.Item
      className={formClassName}
      name={name}
      translationRoot={translationRoot}
      label={t([translationRoot, "action_type.title"])}
      hidePlaceholder
      hideBorder
      hideDescription
      variant="extra-bottom-margin"
    >
      <Form.TextSelect
        name={name}
        initialValue={actionTypeInitialValue}
        options={[
          {
            value: ACTION_TYPE.DO_NOTHING,
            label: t([translationRoot, "action_type.do_nothing"]),
          },
          {
            value: ACTION_TYPE.REDIRECT_TO,
            label: t([translationRoot, "action_type.redirect_to"]),
          },
        ]}
      />
    </Form.Item>
  );
};
